import PrivatePage from 'routes/layout/private';
import PublicPage from 'routes/layout/public';
import { Route, Navigate, Routes, HashRouter } from 'react-router-dom';
import { routes } from 'routes/routes-path';
import Login from 'pages/public/login';
import ForgotPassword from 'pages/public/forgot-password';
import { getItemFromLocalStorage } from 'helpers/localstorage';
import ResetPassword from 'pages/public/reset-password';
import NotFound from 'components/not-found';
import { Suspense } from 'react';
import { usersRoles } from 'helpers/utils';
import { useAppSelector } from 'hooks/useAppDispatchSelector';
import { useTranslation } from 'react-i18next';

const Router = () => {
  const { t } = useTranslation();
  const { user, selectedOrganization } = useAppSelector(state => state.auth);
  const auth = getItemFromLocalStorage('user') || user || null;
  const selectedAuthOrganization = getItemFromLocalStorage('org') || selectedOrganization || {};
  const getRedirectRoute = () => {
    switch (selectedAuthOrganization?.role_name) {
      case usersRoles.SUPER_ADMIN:
        return <Navigate to="/organizations" replace />;
      case usersRoles.CALL_CENTER:
        return <Navigate to="/alerts" replace />;
      case usersRoles.DEALER_ADMIN:
        return <Navigate to="/users" replace />;
      case usersRoles.FLEET_MANAGE:
        return <Navigate to="/vehicles" replace />;
      default:
        return <Navigate to="/users" replace />;
    }
  };
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={auth ? <PrivatePage /> : <PublicPage />}>
          <Route path="*" element={<NotFound />} />
          <Route
            path="/"
            element={auth ? getRedirectRoute() : <Navigate to={'/login'} replace />}
          />
          <Route path="/login" element={auth ? getRedirectRoute() : <Login />} />
          <Route path="/forgot-password" element={auth ? getRedirectRoute() : <ForgotPassword />} />
          <Route
            path="/reset-password/:token"
            element={auth ? getRedirectRoute() : <ResetPassword />}
          />
          {(routes || []).map(route => (
            <Route
              path={route.path}
              key={route?.path}
              element={
                auth ? (
                  <Suspense
                    fallback={
                      <div className="w-full h-full flex items-center justify-center">
                        <p className="font-semibold text-2xl ">{t('LOADING')}</p>
                      </div>
                    }
                  >
                    {route.element}
                  </Suspense>
                ) : (
                  <Navigate to="/" replace />
                )
              }
            />
          ))}
        </Route>
      </Routes>
    </HashRouter>
  );
};

export default Router;
